class BillingAddressModel {
  constructor({ id, firstName, lastName, address, city, state, zip, country, phone }) {
    this._id = id;
    this._firstName = firstName;
    this._lastName = lastName;
    this._address = address;
    this._city = city;
    this._state = state;
    this._zip = zip;
    this._country = country;
    this._phone = phone;
  }

  get id() {
    return this.id;
  }

  get firstName() {
    return this._firstName;
  }

  get lastName() {
    return this._lastName;
  }

  get address() {
    return this._address;
  }

  get city() {
    return this._city;
  }

  get state() {
    return this._state;
  }

  get zip() {
    return this._zip;
  }

  get country() {
    return this._country;
  }

  get phone() {
    return this._phone;
  }

  toJSON() {
    return {
      id: this._id,
      firstName: this._firstName,
      lastName: this._lastName,
      address: this._address,
      city: this._city,
      state: this._state,
      zip: this._zip,
      country: this._country,
      phone: this._phone,
    };
  }
}

export default BillingAddressModel;
